var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11008 10.8898C7.11008 9.10795 7.11008 8.21701 7.66365 7.66343C8.21725 7.10986 9.1082 7.10986 10.8901 7.10986H11.5201C13.302 7.10986 14.193 7.10986 14.7466 7.66343C15.3001 8.21701 15.3001 9.10795 15.3001 10.8898V11.5198C15.3001 13.3017 15.3001 14.1926 14.7466 14.7462C14.193 15.2998 13.302 15.2998 11.5201 15.2998H10.8901C9.1082 15.2998 8.21725 15.2998 7.66365 14.7462C7.11008 14.1926 7.11008 13.3017 7.11008 11.5198V10.8898Z",
    stroke: "#212129",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.15 7.11015C12.1485 5.2472 12.1204 4.28224 11.578 3.62152C11.4733 3.49392 11.3564 3.37692 11.2288 3.2722C10.5317 2.7002 9.4962 2.7002 7.42505 2.7002C5.35392 2.7002 4.31836 2.7002 3.62135 3.2722C3.49375 3.37691 3.37675 3.49392 3.27203 3.62152C2.70001 4.31851 2.70001 5.35405 2.70001 7.42514C2.70001 9.49624 2.70001 10.5318 3.27203 11.2288C3.37675 11.3564 3.49375 11.4734 3.62135 11.5781C4.28209 12.1204 5.24707 12.1485 7.11005 12.15",
    stroke: "#212129",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/clone.1f2399a9284b53b4bb309a800bb10e72.svg";
export { ForwardRef as ReactComponent };